import { render, staticRenderFns } from "./NoticeTestCard.vue?vue&type=template&id=faa3f4fa&scoped=true&"
import script from "./NoticeTestCard.vue?vue&type=script&lang=js&"
export * from "./NoticeTestCard.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTestCard.vue?vue&type=style&index=0&id=faa3f4fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa3f4fa",
  null
  
)

export default component.exports